import { app } from '../../../../../app';
import { Controller } from './all-accounts.controller';

app.component('companyUserDirectoriesDirectoryGroupsAllAccounts', {
    bindings: {
        directoriesDto: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./all-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/all-accounts.component.js